/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Group_GiveawaysInputs */



/**
* | output |
* | --- |
* | "Giveaways" |
*
* @param {Features_Group_GiveawaysInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const features_group_giveaways = /** @type {((inputs?: Features_Group_GiveawaysInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Group_GiveawaysInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Розыгрыши")
	return /** @type {LocalizedString} */ ("Giveaways")
});